<template>
  <v-app>
    <div class="bckdiv">
      <v-container>
          <v-layout align-center justify-center style="margin-top:200px">
              <v-flex xs12 md8>
                <h1 class="white--text p-5" style="text-align:center">Packages</h1>

              </v-flex>
            </v-layout>
                         
              </v-container>
    </div>
    
    <v-container>

      <v-layout row wrap>
        <v-flex xs12 sm12 md6 style="padding-right: 3px;">
          <v-card
    class="mx-auto"
    max-width="100%"
    v-bind:class="{ active: isActive, 'is-show': domestic }"
    
  ><!-- v-bind:class="{'is-show': domestic==true, 'is-hide': domestic==false}" -->
    <v-img
      src="https://img.freepik.com/premium-vector/india-with-ancient-modern-building-with-water-reflection_49537-88.jpg"
      height="200px"
      cover
    ></v-img>

    <v-layout row wrap class="container">
      <v-flex sm6 xs6 md6>
        <h4 style="margin-top: 10px;">Domestic Tours</h4>
      </v-flex>
      <v-flex sm6 xs6 md6 style="text-align: right;">
        <v-icon style="background-color: #024C94;color: white;padding: 7px;border-radius: 50%;" right @click="showBtn('art1')">arrow_drop_down</v-icon>
      </v-flex>
    </v-layout>
          </v-card>
        </v-flex>

        <v-flex xs12 sm12 md6 style="padding-left: 3px;">
          <v-card
    class="mx-auto"
    max-width="100%"
    v-bind:class="{ active: isActive, 'is-show': international }"
  >
    <v-img
      src="https://media.istockphoto.com/id/494184099/photo/travel.jpg?s=170667a&w=0&k=20&c=-e-7TfwLgBcFBLqzvBjDg3aUeEV286v7wGJvTd4LgTs="
      height="200px"
      cover
    ></v-img>

    <v-layout row wrap class="container">
      <v-flex sm6 xs6 md6>
        <h4 style="margin-top: 10px;">International Tours</h4>
      </v-flex>
      <v-flex sm6 xs6 md6 style="text-align: right;">
        <v-icon style="background-color: #024C94;color: white;padding: 7px;border-radius: 50%;" right @click="showBtn1('art1')">arrow_drop_down</v-icon>
      </v-flex>
    </v-layout>
          </v-card>
        </v-flex>
      </v-layout>


      
    </v-container>

    <div ref="art1">
      <v-layout row wrap v-if="tourPackage.length > 0 && domestic == true" >

<v-flex xs12 md3 sm12 style="padding:20px" v-for="item in tourPackage" :key="item.id" >
  <v-card class="mx-auto" max-width="344" style="height: 420px;">
    <v-img :src=item.src height="200px" cover></v-img>
        <div class="p-2">
        <div style="height: 120px;">
          <h4 class="mt-2">{{ item.name }}</h4>
          <p>{{ item.city }}</p>
        </div>
          <div class="mx-2" >
            <div class="row">
              <div class="col" style="margin-top: 7px;">
                <span style="padding: 15px;background-color: #034B93;border-radius: 50%;color: white;font-size: 18px;font-weight: bold;height: 10px;width: 10px;"><span v-if="item.day<10">0</span>{{ item.day }}</span> <span style="font-size:18px;"> Days</span>
              </div>
              <div class="col">
                <v-btn
                  small
                  depressed
                  block
                  style="background-color:red;border-radius: 5px;"
                  class="white--text"
                  @click="view(item)"
                >
                  View Details
                </v-btn>
              </div>
            </div>
          </div>
        </div>
      </v-card>
    </v-flex>

    </v-layout>

    <v-layout row wrap v-if="tourPackage1.length > 0 && international == true" >

<v-flex xs12 md3 sm12 style="padding:20px" v-for="item in tourPackage1" :key="item.id" >
  <v-card class="mx-auto" max-width="344" style="height: 420px;">
    <v-img :src=item.src height="200px" cover></v-img>
        <div class="p-2">
        <div style="height: 120px;">
          <h4 class="mt-2">{{ item.name }}</h4>
          <p>{{ item.city }}</p>
        </div>
          <div class="mx-2" >
            <div class="row">
              <div class="col" style="margin-top: 7px;">
                <span style="padding: 15px;background-color: #034B93;border-radius: 50%;color: white;font-size: 18px;font-weight: bold;height: 10px;width: 10px;"><span v-if="item.day<10">0</span>{{ item.day }}</span> <span style="font-size:18px;"> Days</span>
              </div>
              <div class="col">
                <v-btn
                  small
                  depressed
                  block
                  style="background-color:red;border-radius: 5px;"
                  class="white--text"
                  @click="view(item)"
                >
                  View Details
                </v-btn>
              </div>
            </div>
          </div>
        </div>
      </v-card>
    </v-flex>

    </v-layout>
    </div>
    

    </v-app>
</template>

<script>
import config from "./../../config.json";
export default {
  data() {
    return {
      tab: 'Appetizers',
        items: [
        ],
        domestic: true,
        international: false,
        tourPackage:[],
        tourPackage1:[],
        isActive: true,
        hasError: true

    };
  },
    
  mounted() {
     
        this.axios
        .get(config.API + "TourPackages1", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          console.log(res);
          this.tourPackage = res.data;
        });

        this.axios
        .get(config.API + "TourPackages2", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          console.log(res);
          this.tourPackage1 = res.data;
        });
   },

  methods: {
    showBtn(refName) {
      this.international=false;
      this.domestic=true;
      var element = this.$refs[refName];
      var top = element.offsetTop;
      window.scrollTo(-0.5, top);
    },
       view(des) {
      this.$router.push("/packageDetails/" + des.id);
    },
    showBtn1(refName) {
      this.international=true;
      this.domestic=false;
      var element = this.$refs[refName];
      var top = element.offsetTop;
      window.scrollTo(0, top);
    }
  }
};
</script>

<style scoped>
@import '../../HomeCss/home.css';

@import url('https://fonts.googleapis.com/css?family=Montserrat|Space+Mono&display=swap');
@import url('https://fonts.googleapis.com/css?family=Bree+Serif|Squada+One&display=swap');
</style>

<style scoped>
  v-app {
    font-family: 'Jost', sans-serif!important;

  }
  .package-details {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}
.review {
  display:flex;
}
.rating-icon {
    display:flex;
    justify-content: space-around;
}
.tour-packages-img {
  max-width: 400px!important;

  max-height: 400px!important;
}
.tour-packages-img img {
  max-width: 400px!important;

  max-height: 400px!important;
}
.price {
  display: flex;
  justify-content: space-between;
}
.price-box p{
  margin-bottom: 5px;
  font-weight: 500;
}
.bgclr {
    width: 100%;
    height: 350px;
    background-image: linear-gradient(#7b1fa2, #e91e63);
}
.v-card {
  padding: 10px;
  border-radius: 8px;
}
.gallery-img {
  max-width: 100%;
  padding: 10px;
  border-radius: 10px!important;
}
.v-sheet--offset {
  top: -30px;
  position: relative;
}
.txtcntr {
  text-align: center;
}
.mrgn {
  margin-top: 50px;
}
h1.heading_1 {
  width: 100% !important;
}

.bg_clr {
  background-color: grey;
}

.heading_1 {
  font-family: 'Space Mono', monospace;
  text-align: center !important;
}
.main_icon {
  text-align: center !important;
}
.swo {
  box-shadow: none !important;
}
.opa {
  opacity: 1;
}
.why-us-img img{
 max-width: 100%;
 max-height: 100%;
 margin-bottom: 25px;
}
.about-us-img {
  max-width: 100%;
  border-radius: 5px;
}
.about-us {
  padding: 15px;
}
.about-us .heading-2 {
 
  color: #697488;

}
.why-us-box {
  padding:20px 50px;
}
.why-us p,.why-us-box p {
  color: #697488;
}
.box {
text-align: center;
}
.box h1 {
  color: #051036;
  font-weight: bold;
}
.box p {
  color: #697488;
}
.team-card {
  color:#051036;
}
.team-card img {
  height: 200px;
  width: 200px;
  border-radius: 5px;
  margin-bottom: 15px;
}
.hotel_name {
  font-family: 'Space Mono', monospace;
  font-weight: bold;
}
.enquiry {
    font-family: 'Bree Serif', serif;
}
.contact_tag {
    font-family: 'Space Mono', monospace;
}
.bckdiv {
    background-image: url("../../assets/contact.jpg");
    height: 400px;
    background-size: cover;
}
.is-show {
  border-color: #0b237c !important;
  background-color: #cfd8fa !important;
}
.is-hide {
  border-color: white;
}
.theme--light.v-tabs__bar {
  background-color: #0b237c!important;
}
.v-tabs__item:active{
  opacity: 1!important;
}

@media screen and (max-width: 763px) {
  .rspnsv {
    width: 100%;
    height: auto;
    margin-bottom: 20px;
    background-position: center;
    background-size: cover;
  }
  .team-card {
    text-align: center;
  }
  .help {
    padding-right: 0px !important;
  }
  .aboutTop {
      margin-top: 180px;
      margin-bottom: 100px;
  }
}
@media screen and (min-width: 768px){
  .xyz {
      height: 625px;
  }
}
</style>
